(function() {
  'use strict';
  angular.module('general', ['common']);
  
})();